import { createContext } from 'react'

const DocumentSignerConfigContext = createContext({
  resource: {
    require_signers: false,
    require_signers_order: false,
    entity_id: false,
    isPersisted: false,
    certification_mode: "single_certification"
  }
});

export default DocumentSignerConfigContext;
